import { deepCopy } from "@perxis-auto/shared/lib/lib/copy/deepCopy";
import { instanceOfReference } from "@perxis-auto/shared/lib/lib/instanceOf";
const formatRawFilterValuesData = (data) => {
  const rawFilterValues = deepCopy(data);
  Object.entries(rawFilterValues).forEach(([key, value]) => {
    let flattenedUniqueValue = value;
    if (Array.isArray(flattenedUniqueValue)) {
      flattenedUniqueValue = flattenedUniqueValue.flat();
      rawFilterValues[key] = flattenedUniqueValue;
    }
    if (Array.isArray(flattenedUniqueValue) && flattenedUniqueValue.length && instanceOfReference(flattenedUniqueValue[0])) {
      flattenedUniqueValue = flattenedUniqueValue.filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i);
      rawFilterValues[key] = flattenedUniqueValue;
    }
  });
  return rawFilterValues;
};
export {
  formatRawFilterValuesData
};
